module.exports = "\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/profile/panels/facility-codes/facility-codes.component.css
// module id = ./src/app/profile/panels/facility-codes/facility-codes.component.css
// module chunks = main